<template>
    <component :is="as" class="ui-card-grid">
        <slot />
    </component>
</template>

<script setup lang="ts">
interface Props {
    as?: string;
}

withDefaults(defineProps<Props>(), {
    as: 'div',
});
</script>
